import {GrFormPrevious} from "react-icons/gr";
import {MdNavigateBefore, MdNavigateNext} from "react-icons/md";
import React from "react";
import usePagination from "./usePagination";


const Pagination  = ({
                         displayPages,
                         onPageChange = () => {},
                         currentPage,
                         totalPages,
                         setDisplayPages,
                         handlePrevious= () => {},
                         handleNext,
                         handlePageChange

                     }) => {

    usePagination(currentPage, totalPages, setDisplayPages, displayPages);

    return (
        <div className="pagination-container">

            {currentPage !== 1 &&
                <button className="pagination-item not-current" tabIndex={0} onClick={() => handlePrevious()}>
                    {/*{translations['previousButton']}*/}
                    <MdNavigateBefore/>

                </button>
            }

            {displayPages.map((pageNum, index) => (
                <React.Fragment key={index}>
                    {pageNum === '...' ? (
                        <span className="pagination-ellipsis" tabIndex={0}>{pageNum}</span>
                    ) : (
                        <button
                            className={`pagination-item ${currentPage === pageNum ? 'current' : 'not-current'}`}
                            tabIndex={0}
                            role={"navigation"}
                            onClick={() => handlePageChange(pageNum)}
                        >
                            {pageNum}
                        </button>
                    )}
                </React.Fragment>
            ))}

            {currentPage !== totalPages.length &&
                <button className="pagination-item not-current" tabIndex={0} onClick={() => handleNext()}>
                    {/*{translations['nextButton']}*/}
                    <MdNavigateNext/>
                </button>
            }

        </div>

    ) ;
};

export default Pagination;